import React from 'react';
import { Typography } from '@mui/material';

interface CardTitleProps {
  children: React.ReactNode;
  className?: string;
}

export const CardTitle: React.FC<CardTitleProps> = ({ children, className }) => {
  return (
    <Typography variant="h6" component="div" className={className} sx={{ fontWeight: 'bold' }}>
      {children}
    </Typography>
  );
};
